<template>
  <v-container id="DetalleReporte" class="pt-5">
    <div v-if="showcargando == true" id="cargando" style="z-index: 600;" wire:loading
      class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center">
      <div class="loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4"></div>
      <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
      <p class="w-1/3 text-center text-white">
        Esto puede tardar unos segundos, no cierre esta página.
      </p>
    </div>
    <v-layout row wrap>
      <v-flex xs12 sm6 md4>
        <v-card style="background-color: transparent !important" width="100%" id="DatosGenerales">
          <v-card flat class="text-xs-center ma-3">
            <v-card-title class="justify-center primary">
              <v-toolbar-title id="titulocard">Abogado</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <vs-list>
                <vs-list-item style="padding-left:5px !important" title="Abogado: "
                  :subtitle="this.detalleReporteData.prnombre">


                  <v-row class="btnsAbo">

                    <template v-if="this.detalleReporteData.medallaUrl != 'NA'">
                      <div class="media-middle media-right" style="padding-left:0px">
                        <img class="sq-100 btnMedalla" :src="this.detalleReporteData.medallaUrl" />
                      </div>

                    </template>


                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">


                        <v-btn v-on="on" v-bind="attrs" class="btnAbo" icon fab
                          @click="VistaProveedor(detalleReporteData.prclave)">
                          <v-icon class="btnCar" color="white">
                            mdi-account
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Ver detalle</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">


                        <v-btn v-on="on" v-bind="attrs" class="btnAboNew" icon fab
                          @click="VistaProveedorNewWindow(detalleReporteData.prclave)">
                          <v-icon class="btnsmall" color="white" size="12">
                            mdi-open-in-new
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Abrir en una nueva ventana</span>
                    </v-tooltip>



                  </v-row>





                </vs-list-item>



                <v-card-text>
                  <span><a @click="Reasignaciones()">Reasignaciones</a></span>
                </v-card-text>
                <vs-list-item title="Lider:" :subtitle="this.detalleReporteData.usnom"></vs-list-item>
                <v-card-text v-if="permisoReasignacionesLideres">
                  <span><a @click="ReasignacionesLider()">Reasignaciones</a></span>
                </v-card-text>
              </vs-list>
            </v-card-text>
          </v-card>
          <v-card flat class="text-xs-center ma-3">
            <v-card-title class="justify-center primary">
              <v-toolbar-title id="titulocard">Asegurado</v-toolbar-title>
              <v-spacer></v-spacer>
              <div v-if="validaEdicion">
                <v-btn dark v-if="editasegurado" @click="Editar('Asegurado')" icon>
                  <v-icon color>mdi-lead-pencil</v-icon>
                </v-btn>
                <v-btn dark v-if="!editasegurado" @click="Guardar('Asegurado')" icon>
                  <v-icon color>mdi-content-save</v-icon>
                </v-btn>
                <v-btn dark v-if="!editasegurado" @click="editasegurado = true; Cancelar('Asegurado')" icon>
                  <v-icon color>mdi-keyboard-return</v-icon>
                </v-btn>
              </div>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-form ref="formasegurado" v-model="valid" lazy-validation>
                <vs-list>
                  <template v-if="certificado.length > 0">
                    <vs-list-item title="Número de Membresía: " :subtitle="certificado[0].dacertificado"></vs-list-item>
                  </template>
                  <template v-else>
                    <vs-list-item title="Póliza: " :subtitle="this.detalleReporteData.dapoliza"></vs-list-item>
                    <vs-list-item title="Inciso:" :subtitle="this.detalleReporteData.dainciso"></vs-list-item>
                  </template>
                  <vs-list-item title="Asegurado: " :subtitle="this.detalleReporteData.asnombre"></vs-list-item>
                  <vs-list-item v-if="editasegurado" title="Sol./Cond:"
                    :subtitle="this.detalleReporteData.svnomcond"></vs-list-item>
                  <vs-list-item v-if="editasegurado" title="Conductor Fallecido:"
                    :subtitle="this.detalleReporteData.sacondfallecio == 'Si' ? 'Si' : this.detalleReporteData.sacondfallecio == 'No' ? 'No' : ''"></vs-list-item>
                  <vs-list-item v-if="editasegurado" title="Dirección: "
                    :subtitle="this.detalleReporteData.svdirasco"></vs-list-item>
                  <vs-list-item v-if="editasegurado" id="correo" title="E-mail:"
                    :subtitle="this.detalleReporteData.svemail"></vs-list-item>
                  <v-list-item-content v-if="!editasegurado">
                    <span>Sol./Cond.:</span>
                    <v-text-field style="width:100%" :rules="[rules.required]" v-model="asegurado.nombre" outlined
                      autofocus maxlength="50" v-on:blur="asegurado.nombre = asegurado.nombre.trim()"
                      @keydown.enter.prevent>
                    </v-text-field>
                    <span>Conductor Fallecido:</span>
                    <v-radio-group v-model="asegurado.conductorfall" row :rules="[v => !!v || 'Opción requerida']">
                      <v-radio label="Si" style="text-align: center;" value="1"></v-radio>
                      <v-radio label="No" style="text-align: center;" value="2"></v-radio>
                    </v-radio-group>
                    <span>Dirección:</span>
                    <v-text-field style="width:100%" v-model="asegurado.direccion" maxlength="200"
                      v-on:blur="asegurado.direccion = asegurado.direccion.trim()" outlined @keydown.enter.prevent>
                    </v-text-field>
                    <span>E-mail:</span>
                    <v-text-field style="width:100%" v-model="asegurado.correo" outlined maxlength="80"
                      :rules="[rules.required, rules.email]" v-on:blur="asegurado.correo = asegurado.correo.trim()"
                      @keydown.enter.prevent>
                    </v-text-field>
                  </v-list-item-content>
                  <vs-list-item title="Vigencia: " :subtitle="this.detalleReporteData.dafecfin"></vs-list-item>
                  <vs-list-item title="Cobertura:" :subtitle="this.detalleReporteData.dacobertura"></vs-list-item>
                  <vs-list-item
                    v-if="this.detalleReporteData.numAcomp != 0 && this.detalleReporteData.clclave == 'PABOGA'"
                    title="Acompañamientos recibidos: " :subtitle="this.detalleReporteData.numAcomp"></vs-list-item>
                </vs-list>
              </v-form>
            </v-card-text>
          </v-card>
          <DatosContacto></DatosContacto>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 md4>
        <v-card style="background-color: transparent !important" width="100%">
          <v-card flat class="text-xs-center ma-3">
            <v-card-title class="justify-center primary">
              <v-toolbar-title id="titulocard">Asistencia</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <vs-list>
                <vs-list-item :subtitle="this.detalleReporteData.ainombre"></vs-list-item>
              </vs-list>
            </v-card-text>
          </v-card>
          <v-card flat class="text-xs-center ma-3">
            <v-card-title class="justify-center primary">
              <v-toolbar-title id="titulocard">Posible Conclusión</v-toolbar-title>
              <v-spacer></v-spacer>
              <div v-if="validaEdicion && ((permisolider && precierre == 0) || peredicion)">
                <v-btn dark v-if="editaposible" @click="Editar('Posible')" icon>
                  <v-icon color>mdi-lead-pencil</v-icon>
                </v-btn>
                <v-btn dark v-if="!editaposible" @click="Guardar('Posible')" icon>
                  <v-icon color>mdi-content-save</v-icon>
                </v-btn>
                <v-btn dark v-if="!editaposible" @click="Cancelar('Posible')" icon>
                  <v-icon color>mdi-keyboard-return</v-icon>
                </v-btn>
              </div>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <vs-list>
                <vs-list-item v-if="editaposible" :subtitle="this.detalleReporteData.pcnombre"></vs-list-item>
                <v-list-item-content v-if="!editaposible" style="height: 100px">
                  <span style="text-align: center;">{{ posibleconclusion.pcnombre }}</span>
                  <multiselect placeholder="Seleccione un valor" :options="obtenerposible" v-model="posibleconclusion"
                    label="pcnombre" track-by="pcid" :allow-empty="false"
                    deselect-label="No se puede remover el valor seleccionado" selected-label="Seleccionado"
                    style="z-index: 500; position: absolute; width: 96%;" select-label="Seleccionar valor"
                    @input="seleccion()">
                  </multiselect>
                  <span style="color: red; position: absolute;" v-show="validarposible" class="mt-14">{{ errorposible
                  }}</span>
                </v-list-item-content>
                <vs-list-item v-if="this.detalleReporteData.recuperacion != ''" title="Posibilidad de recuperación: "
                  :subtitle="this.detalleReporteData.recuperacion"></vs-list-item>
              </vs-list>
            </v-card-text>
          </v-card>
          <v-card flat class="text-xs-center ma-3">
            <div v-show="showLightbox">
              <LightBox ref="lightbox" :media="media" :show-caption="true" :show-light-box="false"
                @onClosed="CerrarVisor()" />
            </div>
            <v-overlay :value="overlay">
              <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <v-card-title class="justify-center primary">
              <v-toolbar-title id="titulocard">Aseguradora</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <vs-list>
                <vs-list-item title="Aseguradora: " :subtitle="this.detalleReporteData.clnombre">

                  <!-- <input id="input-archivo" class="file-upload-input" type="file" name="file"  @change="cargaArchivo"> -->
                  <v-tooltip top
                    v-if="detalleReporteData.clrutacontrato != null && detalleReporteData.clrutacontrato != ''">
                    <template v-slot:activator="{ on, attrs }">

                      <v-btn class="rounded-full btnAbo" icon dark v-on="on" v-bind="attrs" style="font-size: 20;"
                        :loading="false" @click="VerContrato">
                        <v-icon color>mdi mdi-file-document-multiple-outline</v-icon>
                      </v-btn>

                    </template>
                    <span>Ver contrato</span>
                  </v-tooltip>

                  <!-- <span class="mdi mdi-file-document-multiple-outline"></span> -->
                </vs-list-item>
                <vs-list-item title="Flotilla: " :subtitle="this.detalleReporteData.flnomcomp"></vs-list-item>
                <vs-list-item v-if="this.detalleReporteData.flbroker != ''" title="Broker: "
                  :subtitle="this.detalleReporteData.flbroker"></vs-list-item>
                <vs-list-item title="Producto: " :subtitle="this.detalleReporteData.dpnombre"></vs-list-item>
                <vs-list-item title="Folio aseguradora: "
                  :subtitle="this.detalleReporteData.svfolioaseg"></vs-list-item>
                <div v-if="this.TBPR">
                  <vs-list-item title="Número de parte 'Trolebus': "
                    :subtitle="this.detalleReporteData.sanumptrolebus"></vs-list-item>
                  <vs-list-item title="Persona responsable o quién está enterado: "
                    :subtitle="this.detalleReporteData.sapersonare"></vs-list-item>
                </div>
                <vs-list-item v-if="this.MR" title="Monto RC: "
                  :subtitle="this.detalleReporteData.samontorc"></vs-list-item>
                <vs-list-item v-if="this.ALPAOAOM" title="Asesoría legal por asalto/ataque/multas: "
                  :subtitle="this.detalleReporteData.saasesorialegal"></vs-list-item>
                <div v-if="this.CCE">
                  <vs-list-item title="CIS: " :subtitle="this.detalleReporteData.sacis"></vs-list-item>
                  <vs-list-item title="Carpeta: " :subtitle="this.detalleReporteData.sacarpeta"></vs-list-item>
                  <vs-list-item title="Emisor: " :subtitle="this.detalleReporteData.saemisor"></vs-list-item>
                </div>

              </vs-list>
              <DetalleAgenteBox></DetalleAgenteBox>
            </v-card-text>
          </v-card>
          <DatosEjecutivo></DatosEjecutivo>
          <v-card flat class="text-xs-center ma-3">
            <v-card-title class="justify-center primary">
              <v-toolbar-title id="titulocard">
                Datos del Vehiculo
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <div v-if="validaEdicion">
                <v-btn dark v-if="editaauto" @click="Editar('Auto')" icon>
                  <v-icon color>mdi-lead-pencil</v-icon>
                </v-btn>
                <v-btn dark v-if="!editaauto" @click="Guardar('Auto')" icon>
                  <v-icon color>mdi-content-save</v-icon>
                </v-btn>
                <v-btn dark v-if="!editaauto" @click="Cancelar('Auto')" icon>
                  <v-icon color>mdi-keyboard-return</v-icon>
                </v-btn>
              </div>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-form ref="formauto" v-model="valid" lazy-validation>
                <vs-list>
                  <vs-list-item title="Número de serie: " :subtitle="this.detalleReporteData.svserie"></vs-list-item>
                  <vs-list-item title="Marca: " :subtitle="this.detalleReporteData.svmarca"></vs-list-item>
                  <vs-list-item title="Modelo: " :subtitle="this.detalleReporteData.svmodelo"></vs-list-item>
                  <vs-list-item title="Año: " :subtitle="this.detalleReporteData.svanio"></vs-list-item>
                  <vs-list-item title="Color: " :subtitle="this.detalleReporteData.svcolor"></vs-list-item>
                  <vs-list-item title="Placas: " v-if="editaauto"
                    :subtitle="this.detalleReporteData.svplaca"></vs-list-item>
                  <v-list-item-content v-if="!editaauto">
                    <span>Placas:</span>
                    <v-text-field style="width:100%" :rules="[rules.required, rules.placamin]" v-model="auto.placa"
                      outlined maxlength="9" v-on:blur="auto.placa = auto.placa.trim()" @keydown.enter.prevent>
                    </v-text-field>
                  </v-list-item-content>
                  <vs-list-item title="Número económico: " :subtitle="this.detalleReporteData.danumeco"></vs-list-item>
                  <vs-list-item title="Monto Libro Azul: " v-if="editaauto"
                    :subtitle="this.detalleReporteData.samontoazul"></vs-list-item>
                  <v-list-item-content v-if="!editaauto">
                    <span>Monto Libro Azul:</span>
                    <v-text-field style="width:100%" v-model="auto.monto" @keypress="filter($event)" outlined
                      maxlength="10" v-on:blur="auto.monto = auto.monto.trim()" :rules="[rules.required, rules.monto]"
                      @keydown.enter.prevent>
                    </v-text-field>
                  </v-list-item-content>
                </vs-list>
              </v-form>
            </v-card-text>
          </v-card>
          <v-card flat class="text-xs-center ma-3">
            <v-card-title class="justify-center primary">
              <v-toolbar-title id="titulocard">Reportes Relacionados</v-toolbar-title>
              <v-spacer></v-spacer>
              <div v-if="validaEdicion && perelacion">
                <v-btn dark v-if="agregarRelacion" @click="AgregarRelacion()" icon>
                  <v-icon color>mdi-plus</v-icon>
                </v-btn>
                <v-btn dark v-if="!agregarRelacion" @click="GuardarEnlace()" icon :loading="loadingEnlace">
                  <v-icon color>mdi-content-save</v-icon>
                </v-btn>
                <v-btn dark v-if="!agregarRelacion" @click="CancelarRelacion()" icon>
                  <v-icon color>mdi-keyboard-return</v-icon>
                </v-btn>
              </div>
            </v-card-title>
            <v-card-text>
              <div v-if="cargando">
                <div v-if="reporind.length > 0">
                  <template v-if="!mostrarForm">
                    <div v-for="item in reporind" :key="item.reportes">
                      <v-row>
                        <v-col cols="12">
                          <vs-list-item title="Reporte Destino:">
                            <template #subtitle>
                              <button class=" reporteindice ml-1" style="font-size: 20px; font-weight: 700;"
                                @click="Link(item, 'D')">{{ item.reporteDestino }}
                              </button>
                            </template>
                          </vs-list-item>
                        </v-col>
                      </v-row>
                    </div>
                  </template>
                </div>
                <div v-else>
                  <v-row>
                    <v-col cols="12" md="12">
                      <vs-list-item v-if="!mostrarForm" title=" Reporte Destino: " subtitle="Ninguno"></vs-list-item>
                    </v-col>
                  </v-row>
                </div>
                <div v-if="perelacion && mostrarForm">
                  <v-form ref="frmrelacion" v-model="valid" lazy-validation>
                    <v-row>
                      <v-col cols="12" md="6">
                        <span class="text-subtitle">
                          Reporte:
                        </span>
                        <div>
                          <v-text-field class="mx-1" :rules="[rules.required]" maxlength="10" outlined
                            @keypress="filter($event)" dense @keydown.enter.prevent
                            v-on:blur="nrreporte = nrreporte != null ? nrreporte.trim() : null; validacionExtra = ''"
                            v-model="nrreporte"></v-text-field>
                        </div>
                      </v-col>
                      <v-col cols="12" md="6">
                        <span class="text-subtitle">
                          Indice:
                        </span>
                        <div>
                          <v-text-field class="mx-1" :rules="[rules.required]" maxlength="3" outlined
                            @keypress="filter($event)" dense @keydown.enter.prevent
                            v-on:blur="svindice = svindice != null ? svindice.trim() : null; validacionExtra = ''"
                            v-model="svindice"></v-text-field>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row v-if="validacionExtra != ''">
                      <v-col cols="12">
                        <span style="color: #FF5C93;">{{ validacionExtra }}</span>
                      </v-col>
                    </v-row>
                  </v-form>
                </div>
              </div>
              <div v-else>
                <v-skeleton-loader type="table-heading, list-item-two-line"></v-skeleton-loader>
              </div>
            </v-card-text>
          </v-card>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 md4>
        <v-card style="background-color: transparent !important" width="100%">
          <v-card flat class="text-xs-center ma-3">
            <v-card-title class="justify-center primary">
              <v-toolbar-title id="titulocard">Fechas</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <vs-list>
                <vs-list-item title="Siniestro:" :subtitle="this.detalleReporteData.svfhsiniestro"></vs-list-item>
                <vs-list-item title="Reporte:" :subtitle="this.detalleReporteData.svfhreporte"></vs-list-item>
                <vs-list-item title="Turnado:" :subtitle="this.detalleReporteData.svfhturnado"></vs-list-item>
                <vs-list-item title="Estimada:" :subtitle="this.detalleReporteData.svfhestimada"></vs-list-item>
                <vs-list-item v-if="detalleReporteData.svfhcontacto != ''" title="Contacto:"
                  :subtitle="this.detalleReporteData.svfhcontacto"></vs-list-item>
                <v-list-item-content class="ms-1" v-if="detalleReporteData.svfhcontacto == ''">
                  <span class="text-subtitle">
                    Contacto:
                  </span>
                  <p class="label-text2" v-if="validaEdicion">
                    <v-icon size="16" class="mr-1" v-if="editarfecha" v-on:click="Editar('contacto')">
                      mdi-pencil
                    </v-icon>
                    <v-icon size="16" class="mr-1" v-if="!editarfecha" v-on:click="Guardar('contacto')">
                      mdi-content-save
                    </v-icon>
                    <span> </span>
                    <v-icon size="16" v-if="!editarfecha" v-on:click="editarfecha = !editarfecha" class="mr-1">
                      mdi-keyboard-return
                    </v-icon>
                  </p>
                  <div class="mt-2" v-if="!editarfecha">
                    <span class="text-subtitle" v-if="PermisoSinIVR">
                      Clave:
                    </span>
                    <span class="text-subtitle" v-else>
                      Capturar IVR:
                    </span>
                    <div>
                      <v-form ref="formcontacto" v-model="valid" lazy-validation>
                        <v-text-field class="mx-1" :rules="[rules.required]" outlined autofocus maxlength="16"
                          :type="PermisoSinIVR ? 'password' : ''" @keypress="PermisoSinIVR ? '' : filter($event)"
                          @keydown.enter.prevent v-on:blur="fhcontacto = fhcontacto.trim()"
                          v-model="fhcontacto"></v-text-field>
                      </v-form>
                    </div>
                  </div>

                </v-list-item-content>
                <v-divider v-if="detalleReporteData.svfhcontacto == ''"></v-divider>
                <vs-list-item title="Término:" v-if="detalleReporteData.svfhtermino != ''"
                  :subtitle="this.detalleReporteData.svfhtermino"></vs-list-item>

                <v-list-item-content class="ms-1" v-if="detalleReporteData.svfhtermino == ''">
                  <span class="text-subtitle">
                    Término:
                  </span>
                  <p class="label-text2" v-if="detalleReporteData.svfhcontacto != '' && validaEdicion">
                    <v-icon size="16" class="mr-1" v-if="editarfecha" v-on:click="Editar('termino')">
                      mdi-pencil
                    </v-icon>
                    <v-icon size="16" class="mr-1" v-if="!editarfecha" v-on:click="Guardar('termino')">
                      mdi-content-save
                    </v-icon>
                    <span> </span>
                    <v-icon size="16" v-if="!editarfecha" v-on:click="editarfecha = !editarfecha; Cancelar('termino')"
                      class="mr-1">
                      mdi-keyboard-return
                    </v-icon>
                  </p>
                  <div class="mt-2" v-if="!editarfecha && detalleReporteData.svfhcontacto != ''">
                    <v-form ref="formtermino" v-model="valid" lazy-validation>
                      <span class="text-subtitle" v-if="PermisoSinIVR">
                        Clave:
                      </span>
                      <span class="text-subtitle" v-else>
                        Capturar IVR:
                      </span>
                      <div>

                        <v-text-field class="mx-1" :rules="[rules.required]" maxlength="16" autofocus outlined
                          :type="PermisoSinIVR ? 'password' : ''" @keypress="PermisoSinIVR ? '' : filter($event)"
                          @keydown.enter.prevent v-on:blur="fhcontacto = fhcontacto.trim()"
                          v-model="fhcontacto"></v-text-field>

                      </div>
                    </v-form>
                  </div>
                </v-list-item-content>
                <v-divider v-if="detalleReporteData.svfhtermino == ' '"></v-divider>

                <vs-list-item title="Conclusión:" :subtitle="this.detalleReporteData.svfhconclusion"></vs-list-item>
                <vs-list-item title="Cerrado:" :subtitle="this.detalleReporteData.svfhcerrado"></vs-list-item>
              </vs-list>
            </v-card-text>
          </v-card>
          <v-card flat class="text-xs-center ma-3">
            <v-card-title class="justify-center primary">
              <v-toolbar-title id="titulocard">Lugar de los Hechos</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <vs-list>
                <v-textarea outlined v-model="this.detalleReporteData.svlughec" readonly filled rows="3">
                </v-textarea>
              </vs-list>
            </v-card-text>
          </v-card>
          <v-card flat class="text-xs-center ma-3">
            <v-card-title class="justify-center primary">
              <v-toolbar-title id="titulocard">Observaciones</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <vs-list>
                <v-textarea outlined v-model="this.detalleReporteData.svconversa" readonly filled rows="3">
                </v-textarea>
              </vs-list>
            </v-card-text>
          </v-card>
          <v-card flat class="text-xs-center ma-3">
            <v-card-title class="justify-center primary">
              <v-toolbar-title id="titulocard">Opciones</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-row align="center">
                <v-col cols="12" sm="6">
                  <h5>Control de Citas</h5>
                </v-col>
                <v-col cols="12" sm="6">
                  <div class="text-center">
                    <v-btn fab dark large color="success" @click="clickCitas">
                      <v-icon dark>mdi-calendar-clock</v-icon>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
              <v-row align="center" v-if="permisoWhats">
                <v-col cols="12" sm="6">
                  <h5>Whatsapp</h5>
                </v-col>
                <v-col cols="12" sm="6">
                  <div class="text-center">
                    <v-btn fab dark large color="success" @click="clickWhatsapp" stacked>
                      <v-badge color="error" v-if="showDot">
                        <v-icon dark>mdi-whatsapp</v-icon>
                      </v-badge>
                      <v-btn v-if="showDot == false" fab dark large color="success" dot @click="clickWhatsapp">
                        <v-icon dark>mdi-whatsapp</v-icon>
                      </v-btn>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card flat class="text-xs-center ma-3" v-if="this.detalleReporteData.estatus != 'A'">
            <v-card-title class="justify-center primary">
              <v-toolbar-title id="titulocard">Otros</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <h5 class="mt-2 ml-1"><a @click="Seguimiento()">Seguimiento</a></h5>
            </v-card-text>
          </v-card>
        </v-card>
      </v-flex>
      <br /><br />
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <v-card flat class="text-xs-center ma-3" width="100%">
          <v-card-title class="justify-center primary">
            <v-toolbar-title id="titulocard">Siniestro</v-toolbar-title>
          </v-card-title>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 md4>
        <v-card flat class="text-xs-center ma-3" width="100%">
          <v-card-title class="justify-center primary">
            <v-toolbar-title id="titulocard">Detalle</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <vs-list>

              <vs-list-item title="Av. Previa:" :subtitle="this.detalleReporteData.svnumave"></vs-list-item>
              <v-list-item-content class="ms-1" v-if="editasiniestro">
                <span class="text-subtitle">
                  No. de siniestro:
                </span>
                <p class="label-text2">
                  <v-icon size="15" class="mr-1" v-if="validaEdicion && user == ''" v-on:click="Editar('siniestro')">
                    mdi-pencil
                  </v-icon>
                  {{ this.detalleReporteData.svnumsin }}
                </p>
              </v-list-item-content>
              <v-list-item-content class="ms-1" v-if="!editasiniestro">
                <span class="text-subtitle">
                  No. de siniestro:
                </span>
                <div>
                  <v-form ref="formsiniestros" v-model="valid" lazy-validation>
                    <v-text-field class="mx-1" outlined autofocus
                      :rules="regex != '' ? ObtenerRegex() : [rules.required]" :placeholder="user == '' ? place : ''"
                      maxlength="20" @keydown.enter.prevent v-on:blur="blurSiniestro()" v-model="siniestro"
                      error-messages=""></v-text-field>

                    <v-row>
                      <v-spacer></v-spacer>
                      <v-icon v-on:click="Guardar('siniestro')">
                        mdi-content-save
                      </v-icon>
                      <span> </span>
                      <v-icon v-on:click="Cancelar('siniestro')" class="mr-4">
                        mdi-keyboard-return
                      </v-icon>
                    </v-row>
                  </v-form>
                </div>
              </v-list-item-content>
              <v-divider></v-divider>
              <vs-list-item title="Agencia:" :subtitle="this.detalleReporteData.agnomcve"></vs-list-item>
              <vs-list-item title="Delegación:" :subtitle="this.detalleReporteData.agdelega"></vs-list-item>
              <vs-list-item title="Localidad:" :subtitle="this.detalleReporteData.lonombre"></vs-list-item>
              <vs-list-item title="Estado:" :subtitle="this.detalleReporteData.esnombre"></vs-list-item>
              <v-list-item-content class="ms-1" v-if="editaajustador">
                <span class="text-subtitle" v-if="this.detalleReporteData.clclave == 'SI'">
                  Operador de servicio:
                </span>
                <span class="text-subtitle" v-else>
                  Ajustador:
                </span>
                <p class="label-text2">
                  <v-icon size="15" class="mr-1" v-if="validaEdicion && permisolider" v-on:click="Editar('ajustador')">
                    mdi-pencil
                  </v-icon>
                  {{ this.detalleReporteData.svajustador }}
                </p>
              </v-list-item-content>
              <v-list-item-content class="ms-1" v-if="!editaajustador">
                <span class="text-subtitle" v-if="this.detalleReporteData.clclave == 'SI'">
                  Operador de servicio:
                </span>
                <span class="text-subtitle" v-else>
                  Ajustador:
                </span>
                <div>
                  <v-form ref="formajustador" v-model="valid" lazy-validation>
                    <v-text-field class="mx-1" :rules="[rules.required]" outlined autofocus maxlength="50"
                      @keydown.enter.prevent v-on:blur="ajustador = ajustador.trim()"
                      v-model="ajustador"></v-text-field>
                  </v-form>
                  <v-row>
                    <v-spacer></v-spacer>
                    <v-icon v-on:click="Guardar('ajustador')">
                      mdi-content-save
                    </v-icon>
                    <span> </span>
                    <v-icon v-on:click="Cancelar('ajustador')" class="mr-4">
                      mdi-keyboard-return
                    </v-icon>
                  </v-row>
                </div>
              </v-list-item-content>
              <v-divider></v-divider>
              <vs-list-item title="Estatus:" :subtitle="this.detalleReporteData.svfhconclusion != ' '
                ? 'Concluído'
                : 'Pendiente'
                "></vs-list-item>
            </vs-list>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 md4>
        <v-card flat class="text-xs-center ma-3" width="100%">
          <v-card-title class="justify-center primary">
            <v-toolbar-title id="titulocard">Siniestro</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <vs-list-item subtitle="Colisión ">
              <v-checkbox disabled v-model="this.svcolision" style="margin: 0px"></v-checkbox>
            </vs-list-item>
            <vs-list-item subtitle="Atropello ">
              <v-checkbox disabled v-model="this.svatropello" style="margin: 0px"></v-checkbox>
            </vs-list-item>
            <vs-list-item subtitle="Volcadura ">
              <v-checkbox disabled v-model="this.svvolcadura" style="margin: 0px"></v-checkbox>
            </vs-list-item>
            <vs-list-item subtitle="Robo ">
              <v-checkbox disabled v-model="this.svrobo" style="margin: 0px"></v-checkbox>
            </vs-list-item>
            <vs-list-item subtitle="Acreditación P. ">
              <v-checkbox disabled v-model="this.svacredp" style="margin: 0px"></v-checkbox>
            </vs-list-item>
            <vs-list-item subtitle="Investigación">
              <v-checkbox disabled v-model="this.svinvest" style="margin: 0px"></v-checkbox>
            </vs-list-item>
            <span>Tipo:</span>
            <vs-list-item subtitle="Crucero">
              <v-checkbox disabled v-model="this.svcruzero" style="margin: 0px"></v-checkbox>
            </vs-list-item>
            <vs-list-item subtitle="Cita">
              <v-checkbox disabled v-model="this.svcitas" style="margin: 0px"></v-checkbox>
            </vs-list-item>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 md4>
        <v-card flat class="text-xs-center ma-3" width="100%">
          <v-card-title class="justify-center primary">
            <v-toolbar-title id="titulocard">Delitos</v-toolbar-title>
            <v-spacer></v-spacer>
            <div v-if="validaEdicion && perdelito">
              <v-btn dark v-if="editadelito" @click="Editar('Delitos')" icon>
                <v-icon color>mdi-lead-pencil</v-icon>
              </v-btn>
              <v-btn dark v-if="!editadelito" @click="Guardar('Delitos')" icon>
                <v-icon color>mdi-content-save</v-icon>
              </v-btn>
              <v-btn dark v-if="!editadelito" @click="Cancelar('Delitos')" icon>
                <v-icon color>mdi-keyboard-return</v-icon>
              </v-btn>
            </div>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>

            <vs-list>
              <vs-list-item subtitle="Lesiones ">
                <v-checkbox :disabled="editadelito" v-model="svlesiones" style="margin: 0px"></v-checkbox>
              </vs-list-item>
              <vs-list-item v-if="svlesiones">
                <v-form ref="formdelitos" v-model="valid" lazy-validation>
                  <v-radio-group v-model="lclave" row :rules="[v => !!v || 'Opción requerida']">
                    <v-radio label="Ambulatorias" :readonly="editadelito" value="1"></v-radio>
                    <v-radio label="Hospitalización" :readonly="editadelito" value="2"></v-radio>
                    <!-- <v-radio v-for="item in tipoLesiones" :readonly="editadelito" :label="item.lnombre"
                      :value="item.lclave">
                    </v-radio> -->
                  </v-radio-group>
                </v-form>
              </vs-list-item>
            </vs-list>

            <vs-list-item subtitle="Homicidio">
              <v-checkbox :disabled="editadelito" v-model="svhomicidios" style="margin: 0px"></v-checkbox>
            </vs-list-item>
            <vs-list-item subtitle="DPA">
              <v-checkbox :disabled="editadelito" v-model="svdpa" style="margin: 0px"></v-checkbox>
            </vs-list-item>
            <vs-list-item subtitle="AVC">
              <v-checkbox :disabled="editadelito" v-model="svavc" style="margin: 0px"></v-checkbox>
            </vs-list-item>
            <vs-list-item subtitle="AVGC">
              <v-checkbox :disabled="editadelito" v-model="svavgc" style="margin: 0px"></v-checkbox>
            </vs-list-item>
            <vs-list-item subtitle="Fuga">
              <v-checkbox :disabled="editadelito" v-model="svfuga" style="margin: 0px"></v-checkbox>
            </vs-list-item>
            <vs-list-item subtitle="Aborto">
              <v-checkbox :disabled="editadelito" v-model="svaborto" style="margin: 0px"></v-checkbox>
            </vs-list-item>
            <vs-list-item subtitle="Acta">
              <v-checkbox :disabled="editadelito" v-model="svacta" style="margin: 0px"></v-checkbox>
            </vs-list-item>
            <vs-list-item subtitle="Recuperación">
              <v-checkbox :disabled="editadelito" v-model="svrecuperacion" style="margin: 0px"></v-checkbox>
            </vs-list-item>
            <vs-list-item subtitle="Delito grave">
              <v-checkbox disabled v-model="svdelitograve" style="margin: 0px"></v-checkbox>
            </vs-list-item>

          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import Reporte from "@/services/ExpJur/ExpJur.service.js";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import DatosContacto from "@/components/pages/DatosDeContacto/DatosContacto.vue";
import DatosEjecutivo from "@/components/pages/DatosEjecutivo/DatosEjecutivo.vue";
import WhatsappService from "@/services/Whatsapp/Whatsapp.service.js";
import General from '@/services/ReporteGeneral/ReporteGeneral.service.js';
import SerBusqueda from '@/services/Busqueda/Busqueda.service.js';
import '@/components/pages/Visor/dist/vue-image-lightbox.min.css';
import LightBox from '@/components/pages/Visor/LightBox.vue';
import ArchivosService from '@/services/Archivos/Archivos.service.js';

import DetalleAgenteBox from "@/components/pages/AsistenciaGeneral/components/DetalleAgenteBox.vue";

export default {
  title() {
    return this.$route.meta.title
  },
  components: {
    DatosContacto,
    DatosEjecutivo,
    LightBox,
    DetalleAgenteBox,
  },
  data: function () {
    return {
      valid: true,
      showcargando: true,
      detalleReporteData: [],
      svlesiones: "",
      svavc: "",
      svaborto: "",
      svhomicidios: false,
      svavgc: "",
      svacta: "",
      svdpa: "",
      svfuga: "",
      svrecuperacion: "",
      svrobo: "",
      svcruzero: "",
      svcitas: "",
      svcolision: "",
      svatropello: "",
      svvolcadura: "",
      svacredp: "",
      svinvest: "",
      svdelitograve: "",
      TBPR: false,
      MR: false,
      ALPAOAOM: false,
      CCE: false,
      tipoLesiones: null,
      lclave: '',
      showDot: false,
      permisoWhats: false,
      permisoReasignacionesLideres: false,
      ////
      datos: {},
      validaEdicion: false,
      validaposible: false,
      editasegurado: true,
      editaposible: true,
      editaauto: true,
      editadelito: true,
      editasiniestro: true,
      editaajustador: true,
      precierre: false,
      permisolider: false,
      asegurado: {
        reporte: '',
        indice: '',
        nombre: '',
        conductorfall: '',
        direccion: '',
        correo: '',
      },
      auto: {
        reporte: '',
        indice: '',
        placa: '',
        monto: ''
      },
      tipodelito: '',
      obtenerposible: [],
      posibleconclusion: [],
      siniestro: null,
      ajustador: '',
      validarposible: false,
      errorposible: '',
      rulestextarea: [
        v => !!v || 'Campo requerido',
        v => {
          if (v == null) {
            return true
          }
          else {
            if (v.length < 0) {
              return 'Mínimo 12 Carácteres'
            }

            else
              return true
          }
        },
      ],
      rules: {
        required: value => !!value || 'Campo requerido',
        counter: value => value.length <= 20 || 'Max 20 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Correo invalido'
        },
        monto: value => value >= 15000 && value <= 2000000 || 'Monto invalido',
        placamin: value => value.length >= 4 || 'La placa debe ser de mínimo 4 dígitos',
        siniestros: value => {
          return this.ObtenerRegex(value)
        },
      },
      ///
      perdelito: false,
      PermisoSinIVR: false,
      editarfecha: true,
      fhcontacto: '',
      motivo: 0,
      descripcion: '',
      motivos: [],
      liberado: false,
      user: '',
      regex: '',
      place: '',
      peredicion: false,
      historial: [],
      certificado: [],
      asistenciaurl: '',
      //Ver contrato
      media: [{
        src: '@/',
        type: ''
      }],
      showLightbox: false,
      overlay: false,

      perelacion: false,
      reporind: [],
      agregarRelacion: true,
      mostrarForm: false,
      nrreporte: null,
      svindice: null,
      loadingEnlace: false,
      validacionExtra: '',
      cargando: false,
    };
  },

  computed: {
    ...mapState({ drawer: (state) => state.drawer }),
    ...mapState(["domain", "informationPage"]),
    DRAWER_STATE: {
      get() {
        return this.drawer;
      },
    },
  },
  watch: {
    'liberado'(val) {
      this.motivo = 0;
      this.descripcion = '';
    }
  },
  async mounted() {
    this.datos = await MetodosGenerales.obtenerSessionReporte("reporte");
    this.showcargando = true;
    this.changeReporteMenuOption("Detalle General");
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", this.datos.nrreporte);
    datosReporte.append("svindice", this.datos.svindice);
    await General.ObtenerTipoCertificado(datosReporte).then(data => {
      this.certificado = data.result;
    });
    this.DatosDetalle();
    this.validaConclusion = await MetodosGenerales.getReporteEstatus(this);
    await this.RevisarNotificacion();
    await MetodosGenerales.verificarPermisoSolo(
      this.domain.domainNameForApi,
      "VerificarPermiso",
      "358"
    ).then((response) => {
      if (response.data.length > 0) {
        this.permisoWhats = true;
      }
    });

    await MetodosGenerales.verificarPermisoSolo(
      this.domain.domainNameForApi,
      "VerificarPermiso",
      "62"
    ).then((response) => {
      if (response.data.length > 0) {
        this.permisoReasignacionesLideres = true;
      }
    });
    await this.ObtenerEnlace();
  },
  async created() {
    this.datos = await MetodosGenerales.obtenerSessionReporte("reporte");
    this.asistenciaurl = await MetodosGenerales.ObtenerURL(this.datos);
    this.ValidaEditar();
  },
  methods: {
    ...mapMutations(["changeReporteMenuOption"]),
    blurSiniestro() {

      this.siniestro = this.siniestro = this.siniestro != null ? this.siniestro.trim() : null;


      const regex = new RegExp(this.regex); // Regex dinámica
      if (this.detalleReporteData.clclave == 'GSEG') {
        if (!regex.test(this.siniestro)) {
          return;
        }
        else {

          let dato = this.siniestro;

          // Dividimos el dato en sus partes por el separador '/'
          let partes = dato.split('/');

          // Definimos las longitudes deseadas para cada segmento
          let longitudes = [3, 3, 6, 4];

          // Completamos cada parte al formato deseado
          let datoFormateado = partes
            .map((parte, index) => parte.padStart(longitudes[index], '0')) // Rellenamos con ceros a la izquierda
            .join('/'); // Unimos nuevamente con '/'

          this.siniestro = datoFormateado;
        }
      }
    },
    async Link(item, tipo) {
      let reporte = {
        nrreporte: tipo == "O" ? item.nrreporteOrigen : item.nrreporteDestino,
        svindice: tipo == "O" ? item.svindiceOrigen : item.svindiceDestino,
        aiclave: tipo == "O" ? item.aiclaveOrigen : item.aiclaveDestino,
      };

      var ver = 0;
      let formData = new FormData();
      formData.append("nrreporte", reporte.nrreporte);
      formData.append("svindice", reporte.svindice);
      await SerBusqueda.ObtenerValidacion(this, formData).then(data => {
        ver = data;
      });

      let url = '';

      if (ver == 0) {
        url = this.$router.resolve({ name: `${"DatosIncompletos"}` });
      }
      else {
        let asistenciaurl = await MetodosGenerales.ObtenerURL(reporte);
        url = this.$router.resolve({ path: asistenciaurl + '/ReporteDetalle' });
        await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');
        window.open(url.href, '_blank');
        await MetodosGenerales.guardarEnSesionInfoReporte(this.datos, 'reporte');

      }

    },
    async ObtenerEnlace() {
      var datosReporte = new FormData();
      datosReporte.append("nrreporte", this.datos.nrreporte);
      datosReporte.append("svindice", this.datos.svindice);
      let data = await General.ObtienerEnlacesReportes(datosReporte)
      if (data.success) {
        if (data.result.length > 0) {
          this.reporind = data.result;
        }
        this.cargando = true;
      }
    },
    ObtenerRegex(value) {
      var resultRules = [];
      if (this.regex != '') {
        resultRules.push(
          (v) => new RegExp(this.regex).test(v) || this.mensage
        );
        return resultRules;
      }
      else {
        return;
      }
    },
    changeState(valor) {
      this.descripcion = this.motivos[valor - 1].mtmotivo;
    },
    async VistaProveedor(prclaveP) {

      let reporte = {
        nrreporte: String(this.datos.nrreporte),
        svindice: String(this.datos.svindice),
        aiclave: String(this.datos.aiclave),
        svfhconclusion: String(this.datos.svfhconclusion),
        prclave: String(prclaveP)

      };


      await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');

      this.$router.push({ name: 'DetalleAbogado' }).catch((error) => error);
    },

    async VistaProveedorNewWindow(prclaveP) {

      let reporte = {
        nrreporte: String(this.datos.nrreporte),
        svindice: String(this.datos.svindice),
        aiclave: String(this.datos.aiclave),
        svfhconclusion: String(this.datos.svfhconclusion),
        prclave: String(prclaveP)

      };


      await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');

      //this.$router.push({ name: 'DetalleAbogado' }).catch((error) => error);
      const routeData = this.$router.resolve({ name: 'DetalleAbogado' });
      window.open(routeData.href, '_blank');
    },




    async Guardar(dato) {
      let datos = [];
      if (dato == 'Asegurado') {
        this.asegurado.nombre = this.asegurado.nombre.trim();
        this.asegurado.correo = this.asegurado.correo.trim();
        if (this.$refs.formasegurado.validate()) {
          this.showcargando = true;
          datos.push(this.asegurado);
          var datosReporte = new FormData();
          datosReporte.append("data", JSON.stringify(datos));
          await General.GuardarAsegurado(this, datosReporte).then(data => {
            if (data[0].success == 'true') {
              this.DatosDetalle();
              this.editasegurado = true;
            }
            else {
              this.$swal(
                "Atención",
                data[0].mensaje,
                "warning"
              );
            }
            this.showcargando = false;
          });


        }
      }
      else if (dato == 'Posible') {
        if (this.posibleconclusion.length == 0) {
          this.validarposible = true;
          this.errorposible = 'Selección requerida';
        }

        if (this.validarposible == false) {
          this.showcargando = true;
          var datosReporte = new FormData();
          datosReporte.append("nrreporte", this.datos.nrreporte);
          datosReporte.append("svindice", this.datos.svindice);
          datosReporte.append("pcid", this.posibleconclusion.pcid);
          await General.GuardarPosibleConclusion(this, datosReporte).then(data => {
            if (data[0].success == 'true') {
              this.DatosDetalle();
              this.editaposible = true;
            }
            else {
              this.$swal(
                "Atención",
                data[0].mensaje,
                "warning"
              );
            }
            this.DatosDetalle();
            this.showcargando = false;
          });
        }
      }
      else if (dato == 'Auto') {
        this.auto.placa = this.auto.placa.trim();
        this.auto.placa = this.auto.placa.replace(/\s*$/, "");
        if (this.$refs.formauto.validate()) {
          this.showcargando = true;
          var datosReporte = new FormData();
          datosReporte.append("reporte", this.datos.nrreporte);
          datosReporte.append("indice", this.datos.svindice);
          datosReporte.append("placa", this.auto.placa);
          datosReporte.append("monto", this.auto.monto);
          await General.DatosVehiculo(this, datosReporte).then(data => {
            if (data[0].success == 'true') {
              this.DatosDetalle();
              this.editaauto = true;
            }
            else {
              this.$swal(
                "Atención",
                data[0].mensaje,
                "warning"
              );
            }
          });

          this.showcargando = false;
        }

      }
      else if (dato == 'Delitos') {
        var datosReporte = new FormData();
        datosReporte.append("reporte", this.datos.nrreporte);
        datosReporte.append("indice", this.datos.svindice);
        datosReporte.append("svlesiones", this.svlesiones);
        datosReporte.append("svhomicidios", this.svhomicidios);
        datosReporte.append("svdpa", this.svdpa);
        datosReporte.append("svavc", this.svavc);
        datosReporte.append("svavgc", this.svavgc);
        datosReporte.append("svfuga", this.svfuga);
        datosReporte.append("svaborto", this.svaborto);
        datosReporte.append("svacta", this.svacta);
        datosReporte.append("svrecuperacion", this.svrecuperacion);
        datosReporte.append("uslogin", MetodosGenerales.ObtenerUserName());
        if (this.svlesiones) {
          datosReporte.append("lesionesTipo", this.lclave);
          if (this.$refs.formdelitos.validate()) {
            this.showcargando = true;
            await General.GuardarDelitos(this, datosReporte).then(data => {
              if (data) {
                this.$emit('ReloadEncabezado');
                this.DatosDetalle();
                this.editadelito = true;
              }
              else {
                this.$swal(
                  "Atención",
                  "Ocurrio un error al intentar guardar los datos del delito",
                  "warning"
                );
              }
            });


            this.showcargando = false;
          }
        }
        else {
          this.showcargando = true;
          await General.GuardarDelitos(this, datosReporte).then(data => {
            if (data) {
              this.$emit('ReloadEncabezado');
              this.DatosDetalle();
              this.editadelito = true;
            }
            else {
              this.$swal(
                "Atención",
                "Ocurrio un error al intentar guardar los datos de la posible conclusión",
                "warning"
              );
            }
          });


          this.showcargando = false;
        }


      }
      else if (dato == 'siniestro') {

        this.siniestro = this.siniestro.trim();
        this.siniestro = this.siniestro.replace(/\s*$/, "");
        this.$refs.formsiniestros.validate();
        let validacions = this.$refs.formsiniestros.validate();
        if (validacions) {
          this.showcargando = true;
          var datosReporte = new FormData();
          datosReporte.append("reporte", this.datos.nrreporte);
          datosReporte.append("indice", this.datos.svindice);
          datosReporte.append("numsiniestro", this.siniestro);
          await General.GuardarNumSiniestro(this, datosReporte).then(data => {
            if (data[0].success == 'true') {
              this.DatosDetalle();
              this.editasiniestro = true;
            }
            else {
              this.$swal(
                "Atención",
                data[0].mensaje,
                "warning"
              );
            }
          });
          this.showcargando = false;
        }
      }
      else if (dato == 'ajustador') {
        this.ajustador = this.ajustador.trim();
        this.ajustador = this.ajustador.replace(/\s*$/, "");
        if (this.$refs.formajustador.validate()) {
          this.showcargando = true;
          var datosReporte = new FormData();
          datosReporte.append("reporte", this.datos.nrreporte);
          datosReporte.append("indice", this.datos.svindice);
          datosReporte.append("ajustador", this.ajustador);
          await General.GuardarAjustador(this, datosReporte).then(data => {
            if (data[0].success == 'true') {
              this.DatosDetalle();
              //this.editasiniestro = true;
              this.editaajustador = true;
            }

            else {
              this.$swal(
                "Atención",
                data[0].mensaje,
                "warning"
              );
            }
          });
          this.showcargando = false;
        }

      }
      else if (dato == 'contacto') {

        this.fhcontacto = this.fhcontacto.trim();
        this.fhcontacto = this.fhcontacto.replace(/\s*$/, "");
        if (this.$refs.formcontacto.validate()) {
          this.showcargando = true;
          let formdata = new FormData();
          formdata.append("nrreporte", this.datos.nrreporte);
          formdata.append("svindice", this.datos.svindice);
          formdata.append("clave", this.fhcontacto);
          formdata.append("permiso", this.PermisoSinIVR);
          formdata.append("uslogin", MetodosGenerales.ObtenerUserName());
          await General.ActualizarContacto(this, formdata).then(data => {
            if (data[0].success == 'true') {
              this.DatosDetalle();
              this.editarfecha = true;
            }
            else if (data[0].success == 'acceso') {
              this.$swal(
                "Atención",
                data[0].mensaje,
                "info"
              );
            }
            else {
              this.$swal(
                "Atención",
                data[0].mensaje,
                "warning"
              );
            }
            this.showcargando = false;
          });

        }
      }
      else if (dato == 'termino') {

        this.fhcontacto = this.fhcontacto.trim();
        this.fhcontacto = this.fhcontacto.replace(/\s*$/, "");
        if (this.$refs.formtermino.validate()) {
          this.showcargando = true;
          let formdata = new FormData();
          formdata.append("nrreporte", this.datos.nrreporte);
          formdata.append("svindice", this.datos.svindice);
          formdata.append("clave", this.fhcontacto);
          formdata.append("uslogin", MetodosGenerales.ObtenerUserName());
          await General.ActualizarTerminoAJ(this, formdata).then(data => {
            if (data[0].success == 'true') {
              this.$emit('ReloadEncabezado');
              this.DatosDetalle();
              this.editarfecha = true;
            }
            else if (data[0].success == 'acceso') {
              this.$swal(
                "Atención",
                data[0].mensaje,
                "info"
              );
            }
            else {
              this.$swal(
                "Atención",
                data[0].mensaje,
                "warning"
              );
            }

          });
          this.showcargando = false;
        }


      }
    },
    async Editar(dato) {
      if (dato == 'Asegurado') {
        this.editasegurado = false;
        this.asegurado.nombre = this.detalleReporteData.svnomcond;
        if (this.detalleReporteData.sacondfallecio != '')
          this.asegurado.conductorfall = this.detalleReporteData.sacondfallecio == 'Si' ? "1" : "2";
        this.asegurado.direccion = this.detalleReporteData.svdirasco;
        this.asegurado.correo = this.detalleReporteData.svemail;
        this.asegurado.reporte = this.datos.nrreporte;
        this.asegurado.indice = this.datos.svindice;
      }
      else if (dato == 'Posible') {
        this.editaposible = false;
        let frmdata = new FormData();
        frmdata.append("grupo", 'JUR');
        await General.PosibleConclusion(this, frmdata).then(data => {
          let formdata = new FormData();
          formdata.append("nrreporte", this.datos.nrreporte);
          formdata.append("svindice", this.datos.svindice);
          General.ValidarVehDetenido(this, formdata).then(pos => {
            if (pos == 0) {
              this.obtenerposible = data.filter((item) => item.pcid !== 13)
            }
            else if (pos == 1) {
              this.obtenerposible = data.filter((item) => item.pcid !== 12)
            }
            else {
              this.obtenerposible = data;
            }
          });
          for (let x in data) {
            if (data[x].pcnombre == this.detalleReporteData.pcnombre) {
              this.posibleconclusion = data[x];
            }
          }
        });
      }
      else if (dato == 'Auto') {
        this.editaauto = false;
        this.auto.placa = this.detalleReporteData.svplaca;
        this.auto.monto = this.detalleReporteData.samontoazul.replace(/([^0-9\.\-])/g, '');
      }
      else if (dato == 'Delitos') {
        this.editadelito = false;



      }
      else if (dato == 'siniestro') {
        this.editasiniestro = false;
        this.siniestro = this.detalleReporteData.svnumsin;

      }
      else if (dato == 'ajustador') {
        this.editaajustador = false;
        this.ajustador = this.detalleReporteData.svajustador;
      }
      else if (dato == 'contacto') {
        if (this.detalleReporteData.prclave.substring(0, 5) != 'PENDI') {
          this.editarfecha = !this.editarfecha;
          this.fhcontacto = '';
        }
        else {
          this.$swal(
            "Atención",
            "El reporte debe de estar turnado para ingresar la fecha de Contacto",
            "info"
          );
        }
      }
      else if (dato == 'termino') {
        if (this.detalleReporteData.prclave.substring(0, 5) != 'PENDI') {
          this.editarfecha = !this.editarfecha;
          this.fhcontacto = '';
          this.liberado = false;
          let data = new FormData();
          data.append("mtactivo", 1);
          data.append("mttipo", 'C')
          await General.MotivosNoLib(this, data).then(data => {
            this.motivos = data;
          });
        }
        else {
          this.$swal(
            "Atención",
            "El reporte debe de estar turnado para ingresar la fecha de Término",
            "info"
          );
        }
      }
    },
    Cancelar(dato) {
      if (dato == 'Asegurado') {
        this.editasegurado = true;
        this.asegurado = {};
        this.asegurado.conductorfall = '';
      }
      else if (dato == 'Posible') {
        this.editaposible = true;
        this.posibleconclusion = [];
        this.validarposible = false;
      }
      else if (dato == 'Auto') {
        this.editaauto = true;
        this.auto.placa = '';
        ;
      }
      else if (dato == 'Delitos') {
        this.editadelito = true;
        this.lclave = '';
        this.svlesiones = this.detalleReporteData.svlesiones.toLowerCase() === "true";

        this.svhomicidios = this.detalleReporteData.svhomicidios.toLowerCase() === "true";
        this.svavgc = this.detalleReporteData.svavgc.toLowerCase() === "true";
        this.svacta = this.detalleReporteData.svacta.toLowerCase() === "true";
        this.svdpa = this.detalleReporteData.svdpa.toLowerCase() === "true";
        this.svfuga = this.detalleReporteData.svfuga.toLowerCase() === "true";
        this.svaborto = this.detalleReporteData.svaborto.toLowerCase() === "true";
        this.svrecuperacion = this.detalleReporteData.svrecuperacion.toLowerCase() === "true";
        this.svavc = this.detalleReporteData.svavc.toLowerCase() === "true";
        this.svdelitograve = this.detalleReporteData.svdelitograve.toLowerCase() === "true";
        this.lclave = this.detalleReporteData.lclave;
      }
      else if (dato == 'siniestro') {
        this.editasiniestro = true;
      }
      else if (dato == 'ajustador') {
        this.editaajustador = true;
      }
      else if (dato == 'termino') {
        this.motivo = 0;
      }
    },
    async ValidaEditar() {

      var datosReporte = new FormData();
      datosReporte.append("reporte", this.datos.nrreporte);
      datosReporte.append("indice", this.datos.svindice);
      datosReporte.append("aiclave", this.datos.aiclave);
      await General.ValidarEdiccion(this, datosReporte).then(data => {
        if (data) {
          this.validaEdicion = true;
          this.validaposible = true;
        }

      });
      await General.Precierre(this, datosReporte).then(data => {
        this.precierre = data;
      });

      await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '49, 297, 300, 359, 106').then(response => {
        if (response.data.length > 0) {
          response.data.forEach(object => {
            if (object.peclave == 49)//Permiso lider
              this.permisolider = true;
            else if (object.peclave == 297)
              this.PermisoSinIVR = true;
            else if (object.peclave == 300)
              this.perdelito = true;
            else if (object.peclave == 359)
              this.peredicion = true;
            else if (object.peclave == 106) //permiso para relacionar reportes de Asistencia Civil
              this.perelacion = true;

          });
        }
      });
    },
    filter: function (evt) {
      evt = (evt) ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    seleccion() {
      if (this.posibleconclusion.length != 0)
        this.validarposible = false;
    },
    async Reasignaciones() {

      this.datos.urlname = this.$route.name;
      await MetodosGenerales.guardarEnSesionInfoReporte(this.datos, 'reporte');
      this.$router.push({ path: this.asistenciaurl + '/Reasignacion' });
      //this.$router.push({ name: `ReasignacionExpJur` }).catch((error) => error);
    },
    async ReasignacionesLider() {

      this.datos.urlname = this.$route.name;
      await MetodosGenerales.guardarEnSesionInfoReporte(this.datos, 'reporte');
      this.$router.push({ path: this.asistenciaurl + '/ReasignacionLider' });
      //this.$router.push({ name: `ReasignacionLiderExpJur` }).catch((error) => error);
    },
    async Seguimiento() {

      this.datos.urlname = this.$route.name;
      await MetodosGenerales.guardarEnSesionInfoReporte(this.datos, 'reporte');
      this.$router.push({ path: this.asistenciaurl + '/Seguimiento' });

      //this.$router.push({ name: `SeguimientoGeneralExpJur` }).catch((error) => error);
    },
    async clickCitas() {
      this.datos.urlname = this.$route.name;
      await MetodosGenerales.guardarEnSesionInfoReporte(this.datos, 'reporte');
      this.$router.push({ path: this.asistenciaurl + '/Reporte/Citas' });
      //this.$router.push({ name: 'citasExpJur' }).catch((error) => error);
    },
    clickWhatsapp() {
      this.$router.push({ name: "Whatsapp" }).catch(() => true);
    },
    async RevisarNotificacion() {
      let noti = await WhatsappService.Notification(this, this.datos);

      if (noti.result != null) {
        var isNot = noti.result.Datos[0].Column1;
        if (isNot == "1") {
          this.showDot = true;
        }
      }
    },
    async DatosDetalle() {
      var respuesta = await Reporte.DatosDetalle(this);
      let auxDetalleReporte = respuesta[0];
      for (const [key, value] of Object.entries(auxDetalleReporte)) {
        if (typeof value == "object") { auxDetalleReporte[key] = "" } else { auxDetalleReporte[key] = value.toString() }
      }

      this.detalleReporteData = auxDetalleReporte;

      this.svlesiones =
        this.detalleReporteData.svlesiones.toLowerCase() === "true";
      this.svaborto = this.detalleReporteData.svaborto.toLowerCase() === "true";
      this.svhomicidios =
        this.detalleReporteData.svhomicidios.toLowerCase() === "true";
      this.svavgc = this.detalleReporteData.svavgc.toLowerCase() === "true";
      this.svacta = this.detalleReporteData.svacta.toLowerCase() === "true";
      this.svdpa = this.detalleReporteData.svdpa.toLowerCase() === "true";
      this.svfuga = this.detalleReporteData.svfuga.toLowerCase() === "true";
      this.svrecuperacion =
        this.detalleReporteData.svrecuperacion.toLowerCase() === "true";
      this.svrobo = this.detalleReporteData.svrobo.toLowerCase() === "true";
      this.svcruzero =
        this.detalleReporteData.svcruzero.toLowerCase() === "true";
      this.svcitas = this.detalleReporteData.svcitas.toLowerCase() === "true";
      this.svcolision =
        this.detalleReporteData.svcolision.toLowerCase() === "true";
      this.svatropello =
        this.detalleReporteData.svatropello.toLowerCase() === "true";
      this.svvolcadura =
        this.detalleReporteData.svvolcadura.toLowerCase() === "true";
      this.svacredp = this.detalleReporteData.svacredp.toLowerCase() === "true";
      this.svinvest = this.detalleReporteData.svinvest.toLowerCase() === "true";
      this.svdelitograve =
        this.detalleReporteData.svdelitograve.toLowerCase() === "true";
      this.svavc = this.detalleReporteData.svavc.toLowerCase() === "true";
      if (this.detalleReporteData.sacondfallecio != "") {
        this.detalleReporteData.sacondfallecio =
          this.detalleReporteData.sacondfallecio == "true" ? "Si" : "No";
      }
      if (
        this.detalleReporteData.clclave == "A" &&
        this.detalleReporteData.flclave == "2182"
      ) {
        this.TBPR = true;
      }
      if (this.detalleReporteData.clclave == "BRO12") {
        this.MR = true;
        this.detalleReporteData.samontorc =
          MetodosGenerales.regresarValorMoneda(this.detalleReporteData.samontorc, "$");
      }
      if (this.detalleReporteData.flclave == "2685") {
        this.ALPAOAOM = true;
      }
      if (this.detalleReporteData.clclave == "SI") {
        this.CCE = true;
      }
      this.lclave = this.detalleReporteData.lclave == 0 ? '' : this.detalleReporteData.lclave;
      if (this.detalleReporteData.samontoazul != 0)
        this.detalleReporteData.samontoazul = MetodosGenerales.regresarValorMoneda(this.detalleReporteData.samontoazul, "$");
      else
        this.detalleReporteData.samontoazul = '';
      this.showcargando = false;

      let formdata = new FormData();
      formdata.append("nrreporte", this.datos.nrreporte);
      formdata.append("svindice", this.datos.svindice);
      formdata.append("clclave", this.detalleReporteData.clclave);
      await General.ValidacionRegex(this, formdata).then(data => {
        this.user = data[0].uslogin;
        this.regex = data[0].regex;
        this.place = data[0].place;
        this.mensage = data[0].mensaje;
      });

      await MetodosGenerales.HistorialBusqueda(this.datos, this.detalleReporteData.clnombrecorto);
    },
    async CerrarVisor() {
      var img = {
        src: '@/',
        type: 'img'
      }
      this.media = [];
      this.media.push(img);
      this.showLightbox = false;
      await this.$refs.lightbox.showImage(0);
    },
    async VerContrato() {
      this.showLightbox = false
      this.overlay = true;
      this.media = this.media.filter(obj => obj.src == '@/');

      //  ruta/NombreDelArchivo.ext
      let arr = this.detalleReporteData.clrutacontrato.split("/")
      let archivosResponse = await ArchivosService.ObtenerContrato(arr[0], arr[1])
        .catch((e) => {
          console.log('error: ', e);
        })

      if (archivosResponse.error) {
        this.$swal({
          position: 'center',
          icon: "warning",
          title: "Algo salió mal",
          text: archivosResponse.msg,
          showConfirmButton: true,
          confirmButtonColor: '#536DFE',
          confirmButtonText: 'Aceptar',
          allowOutsideClick: false,
          timer: 3000
        })

        this.overlay = false;
        return;
      }

      await this.RegistrarVisita(archivosResponse.archivo);

      let isPDF = /\.pdf$/i.test(archivosResponse.archivo);

      var file = {
        src: archivosResponse.watch,
        caption: '<h4> Contrato </h4>',
        type: isPDF ? 'pdf' : 'img',
        width: '800px',
        // docid: 123, 
        paginas: 1,
        archivo: archivosResponse.archivo
      };

      this.media.push(file);
      this.media = this.media.filter(obj => obj.src !== '@/');
      this.overlay = false;
      this.showLightbox = true
    },
    async RegistrarVisita(nombreArchivo) {
      var formData = new FormData();
      formData.append("lasitio", 'Prusia+');
      formData.append("lomodulo", 'Robo-ReporteDetalle');
      formData.append("laaccion", "Vio contrato");
      formData.append("lacaracteristicas", this.datos.nrreporte + '-' + this.datos.svindice);
      formData.append("lanombre", nombreArchivo);
      formData.append("ladestinatario", "");

      await ArchivosService.AlmacenarVisitas(formData);
    },
    async ObtenerEnlace() {
      var datosReporte = new FormData();
      datosReporte.append("nrreporte", this.datos.nrreporte);
      datosReporte.append("svindice", this.datos.svindice);
      let data = await General.ObtienerEnlacesReportes(datosReporte)
      if (data.success) {
        if (data.result.length > 0) {
          this.reporind = data.result;
        }
        this.cargando = true;
      }
    },

    async AgregarRelacion() {
      this.agregarRelacion = false;
      this.mostrarForm = true;
    },
    async CancelarRelacion() {
      this.agregarRelacion = true;
      this.mostrarForm = false;
      this.nrreporte = null;
      this.svindice = null;
      this.validacionExtra = '';
    },
    async GuardarEnlace() {
      if (this.$refs.frmrelacion.validate()) {
        if (this.sending) { // Verifica si ya se está enviando
          return; // Si es así, no hace nada
        }
        this.sending = true;
        this.loadingEnlace = true;
        let frmdata = new FormData();
        frmdata.append("nrreporteOrigen", this.datos.nrreporte);
        frmdata.append("svindiceOrigen", this.datos.svindice);
        frmdata.append("aiclaveOrigen", this.datos.aiclave);
        frmdata.append("nrreporteDestino", this.nrreporte);
        frmdata.append("svindiceDestino", this.svindice);
        frmdata.append("uslogin", MetodosGenerales.ObtenerUserName());

        let validacion = await General.validaEnlaceReporte(frmdata);
        if (validacion.success) {
          if (validacion.result[0].Resp == 0) {
            let data = new FormData();
            data.append("nrreporteOrigen", this.datos.nrreporte);
            data.append("svindiceOrigen", this.datos.svindice);
            data.append("nrreporteDestino", this.nrreporte);
            data.append("svindiceDestino", this.svindice);
            data.append("uslogin", MetodosGenerales.ObtenerUserName());
            await General.GuardarEnlaceReporte(data).then(data => {
              if (data.success) {
                this.$swal({
                  position: "center",
                  icon: "success",
                  title: "Éxito!",
                  text: "El enlace de reporte se guardó correctamente",
                  confirmButtonText: "Aceptar",
                  showConfirmButton: true,
                  allowOutsideClick: false,
                  timer: 4000,
                }).then((result) => {
                  this.ObtenerEnlace();
                  this.CancelarRelacion();
                });
              }
              else {
                this.$swal({
                  position: "center",
                  icon: "error",
                  title: "Error!",
                  html: "No se puede guardar, por favor intente de nuevo más tarde, si el problema persiste, pónganse en contacto con el equipo de asistencia técnica",
                  confirmButtonText: "Aceptar",
                  showConfirmButton: true,
                  allowOutsideClick: false,
                  timer: 4000,
                }).then((result) => {

                });
              }
            });

          }
          else {
            this.validacionExtra = validacion.result[0].Msg;
          }
        }
        this.sending = false;
        this.loadingEnlace = false;
      }
    },
    async Link(item, tipo) {
      let reporte = {
        nrreporte: tipo == "O" ? item.nrreporteOrigen : item.nrreporteDestino,
        svindice: tipo == "O" ? item.svindiceOrigen : item.svindiceDestino,
        aiclave: tipo == "O" ? item.aiclaveOrigen : item.aiclaveDestino,
      };

      var ver = 0;
      let formData = new FormData();
      formData.append("nrreporte", reporte.nrreporte);
      formData.append("svindice", reporte.svindice);
      await SerBusqueda.ObtenerValidacion(this, formData).then(data => {
        ver = data;
      });

      let url = '';

      if (ver == 0) {
        url = this.$router.resolve({ name: `${"DatosIncompletos"}` });
      }
      else {
        let asistenciaurl = await MetodosGenerales.ObtenerURL(reporte);
        url = this.$router.resolve({ path: asistenciaurl + '/ReporteDetalle' });
        await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');
        window.open(url.href, '_blank');
        await MetodosGenerales.guardarEnSesionInfoReporte(this.datos, 'reporte');

      }
    },
  },
};

</script>

<style scoped>
.btnMedalla {
  width: 40px;
  height: 40px;
  min-width: fit-content;
  margin-right: 15px
}


@media screen and (max-width: 1300px) {
  .btnMedalla {
    width: 40px;
    height: 40px;
    min-width: fit-content;
    margin-right: 35px
  }
}


@media screen and (max-width: 1400px) and (min-width: 1280px) {
  .btnMedalla {
    width: 40px;
    height: 40px;
    min-width: fit-content;
    margin-right: 35px;
    margin-left: 10px;
  }
}

.text-subtitle {
  font-size: 12.8px;
  font-weight: 700;
}

.label-text2 {
  font-family: "Roboto", sans-serif;
  font-weight: 700 !important;
  font-size: 20px !important;
  margin-bottom: 0px !important;
}

.btnAbo {
  background-color: #536dfe;
  font-size: 20px !important;
  height: 40px !important;
  width: 40px !important;
  margin-left: 5px;
  /*margin-right: 10px;*/
}

.btnsAbo {
  flex-wrap: initial !important;
}

.btnAboNew {
  background-color: #555;
  font-size: 100px !important;
  height: 20px !important;
  width: 20px !important;
}
</style>

<style lang="scss">
@media screen and (max-width: 700px) {
  #DatosGenerales .v-list-item__title {
    font-weight: 100;
    font-size: 0.9rem;
  }

  #DatosGenerales .vs-list--subtitle {
    font-size: 1rem;
    font-weight: 700;
  }
}

@media only screen and (min-width: 700px) and (max-width: 1060px) {
  #DatosGenerales .v-list-item__title {
    font-weight: 100;
    font-size: 1rem;
  }

  #DatosGenerales .vs-list--subtitle {
    font-size: 1.1rem;
    font-weight: 700;
  }
}

@media only screen and (min-width: 1060px) and (max-width: 1364px) {
  #DatosGenerales .v-list-item__title {
    font-weight: 100;
    font-size: 1rem;
  }

  #DatosGenerales .vs-list--subtitle {
    font-size: 1.1rem;
    font-weight: 700;
  }
}

@media only screen and (min-width: 1364px) and (max-width: 2004px) {
  #DatosGenerales .v-list-item__title {
    font-weight: 100;
    font-size: 1.2rem;
  }

  #DatosGenerales .vs-list--subtitle {
    font-size: 1.3rem;
    font-weight: 700;
  }
}

@media only screen and (min-width: 2004px) {
  #DatosGenerales .v-list-item__title {
    font-weight: 100;
    font-size: 1.3rem;
  }

  #DatosGenerales .vs-list--subtitle {
    font-size: 1.4rem;
    font-weight: 700;
  }
}

#correo .list-titles {
  max-width: -webkit-fill-available !important;
}

.vue-lb-container {
  margin-top: 25px
}
</style>